module.exports = __webpack_public_path__ + "img/case-logo-20.b4ffbcf4.png";